// extracted by mini-css-extract-plugin
export var chevron = "_9g-2";
export var dropdownItems = "_9g-0";
export var item = "_9g-1";